import dayjs from "dayjs";

/** @deprecated Removed in new layout. Clean up remaining usages in Task 11. */
export const HEADER_HEIGHT = !window.ReactNativeWebView ? 110 : 0;

/** @deprecated Removed in new layout. Clean up remaining usages in Task 11. */
export const SIDEBAR_WIDTH = !window.ReactNativeWebView ? 360 : 0;

export const MONTHS_12_SHORT: Month[] = Array.from(
	{ length: 12 },
	(_, i) => i
).map((month) => dayjs().month(month).format("MMM") as Month);

/** Minimum number of characters before firing a server-side search / autocomplete request. */
export const SEARCH_MIN_CHARS = 2;

/** Default page size for admin list pages. */
export const DEFAULT_ADMIN_PAGE_SIZE = 20;
